<template>
	<div class="uk-width-expand@m">
		<fieldset class="bb-options">
			<legend class="label">Sizes</legend>
			<div class="input-radios">
				<div class="input"
					v-for="(size,index) in bed_sizes"
					:key="index">
					<label>
						<input type="radio" class="uk-radio" name="size"
							:id="`bedsize-${size.id}`"
							v-model="selected_id"
							:value="size.id"> {{size.mattress_size.name }}</label>
				</div>
			</div>
		</fieldset>
		<NextButtons
			next_route="wood-finish" />
	</div>
</template>

<script>
	import NextButtons from '../components/NextButtons.vue';
	import {mapState} from 'vuex';
	export default {
		name : 'choose-size',
		components: {
			NextButtons
		},
		data() {
			return {
				selected_id : null
			}
		},
		mounted(){
			if(this.selected_size != null){
				document.getElementById(`bedsize-${this.selected_size.id}`).click();
			}
		},
		methods: {
			/**
			 * check if the current size is selected
			 * @param  {[type]}  size [description]
			 * @return {Boolean}      [description]
			 */
			isSelected(size){
				return (size.id == this.selected_size.id);
			},
			/**
			 * set the currently selectes size.
			 * @param  {[type]} size [description]
			 * @return {[type]}      [description]
			 */
			onSelect(size){
				this.$store.commit('setSelectedSize',size);
			}

		},
		computed : {
			...mapState({
				selected_size : state => state.selected_size,
				bed_sizes : state => state.bed_sizes
			})
		},
		watch : {
			/*bed_sizes(){
				this.selected_id = this.bed_sizes[0].id;
				setTimeout(() => document.getElementById(`bedsize-${this.selected_id}`).click(), 0);
			},*/
			selected_id(){
				for(let i in this.bed_sizes){
					let row = this.bed_sizes[i];
					if(row.id == this.selected_id){
						this.onSelect(row);
						break;
					}
				}
			},
			/**
			 * if local selected is not set
			 * trigger click on the radio button.
			 * @return {[type]} [description]
			 */
			selected_size(newSize){
				if(this.selected_id == null || this.selected_id != newSize.id){
					this.selected_id = this.selected_size.id;
					setTimeout(() => document.getElementById(`bedsize-${this.selected_id}`).click(), 0);
				}
			}
		}
	}
</script>